// export const MapToObject = (map, keys) => keys.map(res => map.get(res));

import { CNS_CATEGORIES } from '@/models/universalDrawer';

export const MapToObject = (map, keys) =>
  keys.map(key => (map.has(key) ? map.get(key) : 'Third Party Risks'));
